// What a drop page item is rendered by: its `__typename`, or for a
// `Drop_Custom_Component` its `name` too, since every custom component shares
// the one typename. Matches the `isDropX` guards `DropPageGenerator` dispatches
// on, and keys `dropSectionImports`.
export const getDropSectionKey = (
	item: { __typename?: string; name?: string | null } | null | undefined
): string | null => {
	if (!item?.__typename) {
		return null;
	}

	if (item.__typename === 'Drop_Custom_Component') {
		return item.name ? `Drop_Custom_Component:${item.name}` : null;
	}

	return item.__typename;
};
